<template>
	<div>
		<v-stepper v-model="step" non-linear>
			<v-stepper-header>
				<v-stepper-step
					:complete="stepComplete[0]"
					:editable="!editarExigencias"
					edit-icon="$vuetify.icons.complete"
					step="1"
				>
					<b>{{ strings[idioma].dados_animal }}</b>
				</v-stepper-step>

				<v-divider />

				<v-stepper-step
					:complete="stepComplete[0]"
					:editable="!editarExigencias && stepComplete[0]"
					edit-icon="$vuetify.icons.complete"
					step="2"
				>
					<b>{{ strings[idioma].calculo_exigencias }}</b>
				</v-stepper-step>
			</v-stepper-header>
			<v-stepper-items style="margin-top: 3px">
				<v-stepper-content
					:style="heightOverflow"
					step="1"
					@scroll.native="onscroll()"
				>
					<Banner />
					<v-layout justify-space-between row wrap>
						<h4 class="v-toolbar__title">{{ strings[idioma].dados_animal }}</h4>
						<div>
							<v-btn
								v-if="
									stepComplete[0] ||
									stepComplete[1] ||
									stepComplete[2] ||
									stepComplete[3] ||
									stepComplete[4]
								"
								color="error"
								@click="resetDieta"
							>
								<v-icon>mdi-delete</v-icon>
								&nbsp;
								{{ strings[idioma].botao_reset }}
							</v-btn>
						</div>
					</v-layout>
					<v-layout v-if="validAnimal != null && !validAnimal" row>
						<span style="color: #f52b1b; font-weight: 400">
							{{ strings[idioma].dados_invalidos }}
						</span>
					</v-layout>
					<span v-if="stepComplete[0]" style="color: black; font-weight: 400">
						{{ strings[idioma].aviso_edicao }}
					</span>
					<v-card v-if="parseInt(step) === 1" class="mb-3">
						<v-form
							ref="formAnimal"
							v-model="validAnimal"
							lazy-validation
							@submit.prevent="calculosPasso1(animal)"
						>
							<v-layout row wrap>
								<v-flex
									v-for="(input, name) in animal"
									:key="name"
									:class="
										input.tipo != TIPO_RADIOBUTTOM ? 'xs12 sm6 md4 lg3' : 'xs12'
									"
									:style="displayCondicional(input, animal)"
									pa-2
								>
									<div v-if="renderCondicional(input, animal)">
										<v-text-field
											v-if="input.tipo === TIPO_NUMBER && !input.oculta"
											v-show="!input.oculta"
											:label="
												input.required
													? input.title[idioma] + ' *'
													: input.title[idioma]
											"
											:rules="rulesAnimal(input, animal, idioma)"
											v-model.lazy="input.valor"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											@focus="input.focus = true"
											@blur="input.focus = false"
											@click="
												parseString(input.valor, idioma) === 0
													? (input.valor = '')
													: ''
											"
											@keypress="(val) => onlyFloat(val, input, 'valor')"
											@change="limpezaDeDados(input, 0, calculo1, [animal])"
										/>
										<v-text-field
											v-if="input.tipo === TIPO_FLOAT2 && !input.oculta"
											v-show="!input.oculta"
											:label="
												input.required
													? input.title[idioma] + ' *'
													: input.title[idioma]
											"
											:rules="rulesAnimal(input, animal, idioma)"
											v-model.lazy="input.valor"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											@focus="input.focus = true"
											@blur="input.focus = false"
											@click="
												parseString(input.valor, idioma) === 0
													? (input.valor = '')
													: ''
											"
											@keypress="(val) => onlyFloat(val, input, 'valor')"
											@change="limpezaDeDados(input, 2, calculo1, [animal])"
										/>
										<v-text-field
											v-if="input.tipo === TIPO_FLOAT_LIVRE && !input.oculta"
											v-show="!input.oculta"
											:label="
												input.required
													? input.title[idioma] + ' *'
													: input.title[idioma]
											"
											:rules="rulesAnimal(input, animal, idioma)"
											v-model.lazy="input.valor"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											@focus="input.focus = true"
											@blur="input.focus = false"
											@click="
												parseString(input.valor, idioma) === 0
													? (input.valor = '')
													: ''
											"
											@keypress="(val) => onlyFloat(val, input, 'valor')"
											@change="limpezaDeDados(input, 2, calculo1, [animal])"
										/>
										<v-text-field
											v-if="input.tipo === TIPO_PORCENTAGEM && !input.oculta"
											v-show="!input.oculta"
											:label="input.title[idioma]"
											:rules="rulesAnimal(input, animal, idioma)"
											v-model.lazy="input.valor"
											suffix="%"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											@focus="input.focus = true"
											@blur="input.focus = false"
											@keypress="(val) => onlyFloat(val, input, 'valor')"
											@change="limpezaDeDados(input, 2, calculo1, [animal])"
										/>
										<v-text-field
											v-if="
												input.tipo === TIPO_PORCENTAGEM_LIVRE && !input.oculta
											"
											v-show="!input.oculta"
											:label="input.title[idioma]"
											:rules="rulesAnimal(input, animal, idioma)"
											v-model.lazy="input.valor"
											suffix="%"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											@focus="input.focus = true"
											@blur="input.focus = false"
											@click="
												parseString(input.valor, idioma) === 0
													? (input.valor = '')
													: ''
											"
											@keypress="(val) => onlyFloat(val, input, 'valor')"
											@change="limpezaDeDados(input, 2, calculo1, [animal])"
										/>
										<v-text-field
											v-if="input.tipo === TIPO_MONEY && !input.oculta"
											v-show="!input.oculta"
											:label="input.title[idioma]"
											v-model.lazy="input.valor"
											:prefix="idioma === 0 || idioma === 2 ? 'R$' : 'U$'"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											@click="
												parseString(input.valor, idioma) === 0
													? (input.valor = '')
													: ''
											"
											@keypress="(val) => onlyFloat(val, input, 'valor')"
											@change="limpezaDeDados(input, 2, calculo1, [animal])"
										/>
										<v-text-field
											v-if="input.tipo === TIPO_RESULTADO && !input.oculta"
											v-show="!input.oculta"
											:label="input.title[idioma]"
											v-model="input.valor"
											class="input-form-animal"
											pattern="\d*"
											inputmode="decimal"
											readonly
										/>
										<div v-else-if="input.tipo === TIPO_RADIOBUTTOM">
											<label v-if="input.title" class="label-radio">
												{{ input.title[idioma] }}
											</label>
											<v-radio-group
												v-show="!input.oculta"
												v-model="input.valor"
												v-bind="binding"
												:rules="
													proximoAnimalClick
														? [(v) => !!v || strings[idioma].obrigatorio]
														: []
												"
												:key="input.valor"
												@change="
													changeRadioAnimal(input, animal);
													stepComplete[0] = false;
												"
											>
												<v-radio
													v-for="option in input.options"
													:key="option.valor"
													:label="option.title[idioma]"
													:value="option.valor"
													:style="
														displayRadioCondicional(input, option, animal)
													"
													color="primary"
												/>
											</v-radio-group>
										</div>
									</div>
								</v-flex>
							</v-layout>
						</v-form>
					</v-card>
					<v-layout row wrap justify-space-between>
						<div>
							<span v-if="alerta !== null && alerta !== ''" style="color: red">
								{{ alerta }}
								<v-dialog
									v-model="alertaDialog"
									:close-on-content-click="false"
									top
									offset-y
									max-width="300"
									transition="slide-x-transition"
								>
									<template v-slot:activator="{ on }">
										<v-btn flat icon color="black" v-on="on">
											<v-icon>mdi-information-outline</v-icon>
										</v-btn>
									</template>
									<v-layout>
										<v-card style="overflow: auto; z-index: 999">
											<v-layout
												pa-2
												align-center
												row
												class="elevation-3 white--text"
												style="background-color: #5c4848; width: 100%"
											>
												<v-flex
													v-for="(item, index) in BezerrosInstrucoes[idioma]
														.header"
													:key="index"
													style="width: 33%"
												>
													<strong>{{ item.titulo }}</strong>
												</v-flex>
											</v-layout>
											<template>
												<v-layout
													v-for="(item, index) in BezerrosInstrucoes[idioma]
														.data"
													:key="index"
													align-center
													row
													class="elevation-1"
												>
													<template>
														<v-flex
															pa-2
															xs4
															style="width: 33%; font-size: small"
															>{{ item.SL }}</v-flex
														>
														<v-flex
															pa-2
															xs4
															style="width: 33%; font-size: small"
															>{{ item.PCMmin }}</v-flex
														>
														<v-flex
															pa-2
															xs4
															style="width: 33%; font-size: small"
															>{{ item.PCMmax }}</v-flex
														>
													</template>
												</v-layout>
											</template>
											<v-card-actions>
												<v-spacer />
												<div style="padding: 2px">
													<i style="font-size: 10pt"
														>{{ strings[idioma].peso_corporal_medio }}:
														{{ animal.peso_corporal_medio.valor }}</i
													>
												</div>
												<v-spacer />
												<v-btn
													:title="strings[idioma].fechar"
													color="error"
													small
													@click="alertaDialog = false"
												>
													<v-icon dark>mdi-close</v-icon>
												</v-btn>
											</v-card-actions>
										</v-card>
									</v-layout>
								</v-dialog>
							</span>
						</div>
						<div>
							<v-btn color="primary" @click="calculosPasso1()">
								{{ strings[idioma].botao_seguinte }}
								<v-icon>mdi-chevron-right</v-icon>
							</v-btn>
						</div>
					</v-layout>
				</v-stepper-content>

				<v-stepper-content
					:style="heightOverflow"
					step="2"
					@scroll.native="onscroll()"
				>
					<Banner />
					<v-layout
						:justify-space-between="!$vuetify.breakpoint.xs"
						:column="$vuetify.breakpoint.xs"
						wrap
					>
						<div>
							<h4 class="v-toolbar__title">
								{{ strings[idioma].calculo_exigencias }}
							</h4>
						</div>
						<div>
							<v-layout
								:justify-space-between="$vuetify.breakpoint.xs"
								row
								wrap
							>
								<div>
									<v-menu
										v-model="menu2"
										:close-on-content-click="false"
										bottom
										right
										offset-y
										transition="slide-y-transition"
									>
										<template v-slot:activator="{ on }">
											<v-btn v-on="on">
												<v-icon>mdi-arrow-down-bold-circle-outline</v-icon>
												&nbsp;
												{{ strings[idioma].exporta }}
											</v-btn>
										</template>
										<v-card>
											<v-list>
												<v-list-tile
													v-for="(item, index) in save_options.filter(
														(e) => e.pertence === 'E'
													)"
													:key="index"
													@click="exporta(item.value)"
												>
													<v-list-tile-content>
														<v-list-tile-title>{{
															item.title[idioma]
														}}</v-list-tile-title>
													</v-list-tile-content>
												</v-list-tile>
											</v-list>
										</v-card>
									</v-menu>
								</div>
								<div>
									<v-menu
										:close-on-content-click="false"
										v-model="menu1"
										bottom
										offset-y
										transition="slide-y-transition"
									>
										<template v-slot:activator="{ on }">
											<v-btn :title="strings[idioma].dados_animal" v-on="on">
												<v-icon>mdi-information-outline</v-icon>
											</v-btn>
										</template>
										<DadosAnimalCard :animal="animal" />
									</v-menu>
								</div>
							</v-layout>
						</div>
					</v-layout>
					<v-card v-if="parseInt(step) === 2" class="mb-3">
						<v-layout
							v-if="loadingStep2 || recalculandoExigencias"
							:style="{ height: heightCard }"
							column
							fill-height
							justify-center
							align-center
						>
							<span
								v-if="recalculandoExigencias"
								style="font-weight: 500; padding: 4px"
							>
								{{ strings[idioma].recalculando_exigencias }}
							</span>
							<span v-else style="font-weight: 500; padding: 4px">
								{{ strings[idioma].calculando_exigencias }}
							</span>
							<v-progress-circular :size="50" color="primary" indeterminate />
						</v-layout>
						<div v-else>
							<Exigencias
								:apenas-calcula="true"
								:editar-exigencias="editarExigencias"
								@stepComplete1="stepComplete[1] = true"
								@stepIncomplete1="stepComplete[1] = true"
								@toggleAll="toggleAll(exigencias, exigencias_selecionadas)"
							/>
						</div>
					</v-card>
					<v-layout row wrap justify-space-between>
						<v-btn @click="step = 1">
							<v-icon>mdi-chevron-left</v-icon>
							{{ strings[idioma].voltar }}
						</v-btn>
					</v-layout>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { VMoney } from "v-money";
import {
	TIPO_NUMBER,
	TIPO_FLOAT2,
	TIPO_FLOAT_LIVRE,
	TIPO_PORCENTAGEM_LIVRE,
	TIPO_RADIOBUTTOM,
	TIPO_RESULTADO,
	TIPO_MONEY,
	TIPO_PORCENTAGEM,
	ID_LEITE_VACA,
	CRESCIMENTO_TERMINACAO,
	BEZERRO,
	VACA,
	FEMEA,
	MIN_PESO_MACHO,
	MIN_PESO_FEMEA,
	MIN_PESO_BEZERRO,
	MAX_PESO_MACHO,
	MAX_PESO_FEMEA,
	MAX_PESO_BEZERRO,
	MAX_GMD,
	MACHO,
	MACHO_CASTRADO,
	EXPORTAR_PDF_COMPLETO,
} from "@/utils/types.js";
import DadosAnimalCard from "./components/DadosAnimalCard.vue";
import Exigencias from "./components/Exigencias.vue";
import Banner from "./components/Banner.vue";
import Animal from "../modules/Animal/Animal";
import { BezerrosInstrucoes } from "../lang/Strings";
import { MULTIPARAS, PRIMIPARAS } from "../utils/types";
export default {
	directives: { money: VMoney },
	components: {
		DadosAnimalCard,
		Exigencias,
		Banner,
	},
	data: () => ({
		BezerrosInstrucoes: BezerrosInstrucoes,
		TIPO_NUMBER: TIPO_NUMBER,
		TIPO_RADIOBUTTOM: TIPO_RADIOBUTTOM,
		TIPO_RESULTADO: TIPO_RESULTADO,
		TIPO_MONEY: TIPO_MONEY,
		TIPO_PORCENTAGEM: TIPO_PORCENTAGEM,
		TIPO_FLOAT2: TIPO_FLOAT2,
		TIPO_FLOAT_LIVRE: TIPO_FLOAT_LIVRE,
		TIPO_PORCENTAGEM_LIVRE: TIPO_PORCENTAGEM_LIVRE,
		CRESCIMENTO_TERMINACAO: CRESCIMENTO_TERMINACAO,
		BEZERRO: BEZERRO,
		VACA: VACA,
		FEMEA: FEMEA,
		MACHO: MACHO,
		MACHO_CASTRADO: MACHO_CASTRADO,
		MIN_PESO_MACHO: MIN_PESO_MACHO,
		MIN_PESO_FEMEA: MIN_PESO_FEMEA,
		MIN_PESO_BEZERRO: MIN_PESO_BEZERRO,
		MAX_PESO_MACHO: MAX_PESO_MACHO,
		MAX_PESO_FEMEA: MAX_PESO_FEMEA,
		MAX_PESO_BEZERRO: MAX_PESO_BEZERRO,
		MAX_GMD: MAX_GMD,
		ID_LEITE_VACA: ID_LEITE_VACA,
		EXPORTAR_PDF_COMPLETO: EXPORTAR_PDF_COMPLETO,
		alimentoClick: [],
		arrayTable: [
			{
				id: "ok",
			},
		],
		calculandoDieta: false,
		calculandoNutrientes: false,
		changeMinMax: false,
		dialogNutrientes: false,
		dietaOtimizada: false,
		dietaSemiOtima: false,
		editarExigencias: false,
		loadingAlimentos: false,
		loadingStep2: false,
		indexAlimentoDialog: 0,
		menu1: false,
		menu2: false,
		menu3: false,
		menu4: false,
		open: [],
		pagination: {
			rowsPerPage: 5,
			sortBy: null,
			descending: false,
			page: 1,
			totalItems: 0,
		},
		recalculandoExigencias: false,
		search: null,
		searchRestricao: null,
		step: 1,
		fixaVC: false,
		stepComplete: [false, false, false, false, false],
		treeAlimentos: [],
		validAnimal: false,
		volumososSelecionados: [],
		concentradoSelecionados: [],
		proximoAnimalClick: true,
		alerta: null,
		alertaDialog: false,
	}),
	computed: {
		...mapState("app", [
			"animal",
			"animal_",
			"strings",
			"idioma",
			"optionsNumber",
			"headersExigencias",
			"exigencias",
			"exigencias_selecionadas",
			"categorias_alimentos",
			"alimentos_selecionados",
			"ingredientes",
			"composicao_racao",
			"composicao_dieta",
			"vc",
			"headersComposicaoRacao",
			"excrecao",
			"headersExigenciasRelatorio",
			"relatorio_financeiro",
			"headersRelatorioFinanceiro",
			"save_options",
			"acesso_premium",
			"user",
		]),
		binding() {
			const binding = {};
			if (this.$vuetify.breakpoint.mdAndUp) binding.row = true;
			else binding.row = false;
			return binding;
		},
		filter() {
			return (item, search, textKey) =>
				item[textKey].toLowerCase().search(search.toLowerCase()) > -1;
		},
		heightCard() {
			return String(this.$vuetify.breakpoint.height - 289) + "px";
		},
		heightDialog() {
			return this.$vuetify.breakpoint.xs
				? String(this.$vuetify.breakpoint.height - 150) + "px"
				: String(this.$vuetify.breakpoint.height - 240) + "px";
		},
		heightOverflow() {
			return (
				"max-height: " +
				String(this.$vuetify.breakpoint.height - 120) +
				"px; overflow: auto; padding-bottom: 65px;"
			);
		},
		heightTree() {
			return (
				"max-height: " +
				String(this.$vuetify.breakpoint.height - 200) +
				"px; overflow: auto; min-height: 200px;"
			);
		},
	},
	watch: {
		loadingStep2(val) {
			let loading = val || this.loadingAlimentos;
			this.$store.commit("setLoading", loading);
		},
		loadingAlimentos(val) {
			let loading = val || this.loadingStep2;
			this.$store.commit("setLoading", loading);
		},
		idioma(val) {
			this.$store.state.app.animal_.useFormat = true;
			this.$store.state.app.animal = this.animal_.getData();
			this.$store.commit("setTipoAnimal", this.$store.state.app.animal);
		},
		step(val) {
			this.$store.state.app.step = val;
		},
	},
	created() {
		this.$store.state.app.tipo = "E";
		this.$store.commit("getDefaultAnimalExigencias");
		this.$store.commit("getDefaultExigencias");
		this.$store.state.app.step = this.step;

		this.fixaVC = false;
		if (!this.$store.state.app.categorias_alimentos) {
			this.loadingAlimentos = true;
			this.axios.post("tipos", {}).then((response) => {
				let tipos = response.data.data;
				this.axios
					.post("relatorio/alimentosBrCorte", {})
					.then((response) => {
						this.$store.commit("setAlimentos", {
							tipos: tipos,
							alimentos: response.data.data,
						});
						this.loadingAlimentos = false;
					})
					.catch((error) => {
						console.log(error);
					});
			});
		}
	},
	methods: {
		...mapActions(["calculaExigencias"]),
		sejaPremium() {
			this.$store.commit("openOKModal", {
				title: "",
				msg: this.strings[this.idioma].funcionalidade_exclusiva_premium,
			});
		},
		onscroll() {
			this.$store.commit("setMenu", false);
			this.menu1 =
				this.menu2 =
				this.menu3 =
				this.menu4 =
				this.menureset1 =
				this.menureset3 =
				this.menureset4 =
				this.menusalvar =
				this.menugrafico1 =
				this.menugrafico2 =
					false;
		},

		limpezaDeDados(input, tipo = 0, fn = null, args = null) {
			let valorSTR = input.valor;
			input.valor = input.valor.replace(
				this.idioma === 0 || this.idioma === 2 ? "." : ",",
				this.strings[this.idioma].separador_float
			);

			let calculaPLe = (valor, idioma) => {
				let result = 0.0;
				switch (this.animal.estado_parides.valor) {
					case PRIMIPARAS:
						result = (
							6.431 -
							0.072 * this.parseString(valor, idioma) -
							6.431 * Math.exp(-2.188 * this.parseString(valor, idioma))
						).toFixed(2);
						break;
					case MULTIPARAS:
						result = (
							7.996 -
							0.101 * this.parseString(valor, idioma) -
							7.996 * Math.exp(-1.447 * this.parseString(valor, idioma))
						).toFixed(2);
						break;
					default:
						result = (
							8.819 -
							0.069 * this.parseString(valor, idioma) -
							8.819 * Math.exp(-3.211 * this.parseString(valor, idioma))
						).toFixed(2);
				}
				return idioma === 0 || idioma === 2
					? String(result).replace(
							new RegExp("[.]", "g"),
							this.strings[idioma].separador_float
					  )
					: String(result);
			};
			if (
				input.id === "PLe" &&
				valorSTR.trim() !== "" &&
				parseFloat(input.valor) === 0
			) {
				this.animal.producao_de_leite.valor = 0;
			} else if (
				input.id &&
				input.id === "SL" &&
				(this.parseString(this.animal.producao_de_leite.valor, this.idioma) >=
					0 ||
					this.animal.producao_de_leite.valor === "")
			) {
				let PLe = calculaPLe(input.valor, this.idioma);
				if (
					this.parseString(this.animal.semana_lactacao.valor, this.idioma) <= 40
				) {
					this.animal.producao_de_leite.valor = PLe;
				}
			}

			if (fn === this.calculo1) {
				fn = null;
				this.calculo1(...args);
				this.$limpezaDeDados(input, tipo, fn, args, this.idioma);
			} else {
				this.$limpezaDeDados(input, tipo, fn, args, this.idioma);
			}
		},
		onlyFloat(val, input, tipo) {
			this.$onlyFloat(val, input, tipo, this.idioma);
		},
		exporta(tipo = "pdf") {
			if (
				!this.getAcessoModulo({
					user: this.user,
					modulo: EXPORTAR_PDF_COMPLETO,
				})
			)
				return this.sejaPremium();
			if (this.temDadosFaltantesUser(this.user)) return;

			let cliente = localStorage.getItem("cliente");
			let clienteID = null;
			if (cliente !== null) {
				cliente = JSON.parse(cliente);
				clienteID = cliente.id;
			}
			this.loadingStep2 = true;
			this.axios
				.post("relatorios/exigencias", {
					exigencias: this.exigencias,
					idioma: this.idioma,
					animal: this.animal,
					idCliente: clienteID,
				})
				.then((res) => {
					let link = document.createElement("a");
					link.href = tipo === "pdf" ? res.data.pdf : res.data.csv;
					link.target = "_blank";
					link.click();
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					this.loadingStep2 = false;
				});
		},
		calculo1(animal) {
			this.usoCalculo1 = true;
			if (this.$store === undefined || this.$store === null) {
				this.usoCalculo1 = false;
				return;
			}
			this.formulacaoCarregada = false;
			this.$store.commit("setTipoAnimal", this.animal);
			setTimeout(() => {
				this.loadingStep2 = true;
				this.step = 1;
				const valido = false; // evito o problema do elemento alterado do errado para o certo;
				this.stepComplete[0] = valido; // inicialmente é dado o passo completo;
				this.$store.commit("setDietaCalculada", !this.formulacaoCarregada);
				this.selected = false;
				this.$nextTick(() => {
					this.stepComplete[0] = this.dieta_calculada;
					setTimeout(() => {
						this.$store.commit("setLeiteDeVaca");
						if (this.categorias_alimentos) {
							this.$store.dispatch("calculaExigencias").then(() => {
								this.search = null;
								this.stepComplete = [true, false];
								this.loadingStep2 = false;
								this.usoCalculo1 = false;
							});
						} else {
							this.usoCalculo1 = false;
						}
					}, 20);
				});
			}, 10);
			var alerta = this.alert;
			if (
				this.animal_.tipo === "bezerro" &&
				this.animal_.semana_lactacao === null
			) {
				alerta(".");
			}
			if (
				this.animal_.tipo === "bezerro" &&
				this.animal_.semana_lactacao !== null
			) {
				this.animal_.useFormat = false;
				var pc =
					(parseFloat(this.animal_.peso_corporal_medio) +
						parseFloat(this.animal_.peso_corporal_medio)) /
					2;
				var sl =
					this.animal_.semana_lactacao === 0 ||
					this.animal_.semana_lactacao === null ||
					isNaN(this.animal_.semana_lactacao)
						? 1
						: this.animal_.semana_lactacao;
				alerta("");
				if (sl >= 1 && sl <= 4) {
					if (pc < 30) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 72) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 5 && sl <= 8) {
					if (pc < 50) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 90) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 9 && sl <= 12) {
					if (pc < 70) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 120) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 13 && sl <= 16) {
					if (pc < 90) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 150) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 17 && sl <= 20) {
					if (pc < 110) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 180) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 21 && sl <= 24) {
					if (pc < 130) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 200) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 25 && sl <= 28) {
					if (pc < 150) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 230) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 29 && sl <= 32) {
					if (pc < 170) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 260) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				} else if (sl >= 33 && sl <= 36) {
					if (pc < 190) {
						alerta(
							this.strings[this.idioma].peso_corporal_abaixo_bezerro + sl + "."
						);
					} else if (pc > 300) {
						alerta(
							this.strings[this.idioma].peso_corporal_acima_bezerro + sl + "."
						);
					}
				}
				this.animal_.useFormat = true;
			} else if (this.animal_.tipo === "bezerro") {
				alerta(this.strings[this.idioma].tabela_de_referencia);
			} else {
				alerta("");
			}
		},
		alert(msg) {
			this.alerta = msg;
		},
		calculosPasso1() {
			const handle = () => {
				this.stepComplete[0] = false;
				this.stepComplete[1] = false;
				this.$store.commit("setLeiteDeVaca");
				if (this.$refs.formAnimal.validate()) {
					this.$store.dispatch("calculaExigencias").then(() => {
						this.temDadosFaltantesUser(this.user);
						this.step = 2;
						this.stepComplete[0] = true;
						this.stepComplete = [true, true];
						this.loadingStep2 = false;
					});
				} else {
					this.step = 1;
					this.stepComplete = [false, false];
					this.loadingStep2 = false;
				}
			};
			const prereq = () => {
				let animal = new Animal(this.$store.state, this.animal);
				animal.useFormat = false;
				var PLe = animal.producao_de_leite;
				var SL = animal.semana_lactacao;
				animal.useFormat = true;
				if (this.animal_.tipo === "bezerro") {
					/* if (this.alerta !== null && this.alerta !== '') {
              return
            } */
					animal.useFormat = false;
					if (SL === null || isNaN(SL) || SL <= 0) {
						SL = 1;
						animal.semana_lactacao = SL;
					}
					if (PLe === undefined || PLe === null || isNaN(PLe) || PLe <= 0) {
						let result = 8.819 - 0.069 * SL - 8.819 * Math.exp(-3.211 * SL);
						switch (animal.estado_parides) {
							case PRIMIPARAS:
								result = 6.431 - 0.072 * SL - 6.431 * Math.exp(-2.188 * SL);
								break;
							case MULTIPARAS:
								result = 7.996 - 0.101 * SL - 7.996 * Math.exp(-1.447 * SL);
						}
						PLe = result;
						if (PLe > 0 && SL <= 40) {
							animal.producao_de_leite = PLe;
						}
					}
					animal.useFormat = true;
				} else if (this.animal_.tipo === VACA) {
					animal.useFormat = false;
					if (SL === null || isNaN(SL) || SL <= 0) {
						SL = 1;
						animal.semana_lactacao = SL;
					}
					if (PLe === undefined || PLe === null || isNaN(PLe) || PLe <= 0) {
						let result = 8.819 - 0.069 * SL - 8.819 * Math.exp(-3.211 * SL);
						switch (animal.estado_parides) {
							case PRIMIPARAS:
								result = 6.431 - 0.072 * SL - 6.431 * Math.exp(-2.188 * SL);
								break;
							case MULTIPARAS:
								result = 7.996 - 0.101 * SL - 7.996 * Math.exp(-1.447 * SL);
						}
						PLe = result;
						if (PLe > 0 && SL <= 40) {
							animal.producao_de_leite = PLe;
						}
					}
					animal.useFormat = true;
				}
				this.$store.commit("setTipoAnimal", animal.getData());
			};
			this.loadingStep1 = true;
			var awaitCalculo1 = setInterval(() => {
				if (!this.usoCalculo1) {
					clearInterval(awaitCalculo1);
					this.usoCalculo1 = false;
					this.loadingStep1 = false;
					prereq();
					setTimeout(handle, 100);
				}
			}, 1);
		},
		displayCondicional(input, animal) {
			if (!input.depende) return null;
			for (var i = 0; i < input.depende.length; i++) {
				if (
					(!input.valorDepende || !input.valorDepende[i]) &&
					animal[input.depende[i]].valor !== null &&
					animal[input.depende[i]].valor !== "" &&
					this.parseString(animal[input.depende[i]].valor, this.idioma) !== 0 &&
					this.renderCondicional(animal[input.depende[i]], animal)
				)
					return null;
				if (!input.valorDepende || !input.valorDepende[i])
					return "display:none";
				if (
					input.valorDepende[i].includes(animal[input.depende[i]].valor) &&
					this.renderCondicional(animal[input.depende[i]], animal)
				)
					return null;
			}
			return "display: none";
		},
		displayRadioCondicional(input, option, animal) {
			if (!option.depende) return null;
			if (
				(option.valorDepende.includes(animal[option.depende].valor) ||
					!animal[option.depende].valor) &&
				this.renderCondicional(animal[option.depende], animal)
			)
				return null;
			if (input.valor === option.valor) input.valor = null;
			return "display: none";
		},
		parseString(valor, idioma) {
			return this.$parseString(valor, idioma);
		},
		renderCondicional(input, animal) {
			if (!input.depende) return true;
			for (var i = 0; i < input.depende.length; i++) {
				if (
					(!input.valorDepende || !input.valorDepende[i]) &&
					animal[input.depende[i]].valor !== null &&
					animal[input.depende[i]].valor !== "" &&
					this.parseString(animal[input.depende[i]].valor, this.idioma) !== 0 &&
					this.renderCondicional(animal[input.depende[i]], animal)
				)
					continue;
				if (!input.valorDepende || !input.valorDepende[i]) continue;
				if (
					input.valorDepende[i].includes(animal[input.depende[i]].valor) &&
					this.renderCondicional(animal[input.depende[i]], animal)
				)
					return true;
			}
			return false;
		},
		renderEstadoFisiologico(animal, estado, index, idioma) {
			if (index === 0) {
				return estado.options[index].title[idioma];
			} else if (index === 1) {
				let text = estado.options[index].title[idioma];
				if (idioma === 0 || idioma === 2)
					text += " | " + animal.producao_de_leite.valor + " kg/dia";
				else text += " | " + animal.producao_de_leite.valor + " kg/day";
				text +=
					" | " +
					animal.semana_lactacao.valor +
					" | " +
					animal.proteina_do_leite.valor +
					" | " +
					animal.gordura_do_leite.valor +
					" | " +
					animal.lactose_do_leite.valor;
				return text;
			} else if (index === 2) {
				let text = estado.options[index].title[idioma];
				text +=
					" | " +
					animal.escore_corporal.valor +
					" | " +
					animal.peso_bezerro_nascimento.valor +
					" | " +
					animal.dias_gestacao.valor;
				return text;
			} else {
				let text = estado.options[index].title[idioma];
				if (idioma === 0 || idioma === 2)
					text += " | " + animal.producao_de_leite.valor + " kg/dia";
				else text += " | " + animal.producao_de_leite.valor + " kg/day";
				text +=
					" | " +
					animal.semana_lactacao.valor +
					" | " +
					animal.proteina_do_leite.valor +
					" | " +
					animal.gordura_do_leite.valor +
					" | " +
					animal.lactose_do_leite.valor;
				text +=
					" | " +
					animal.escore_corporal.valor +
					" | " +
					animal.peso_bezerro_nascimento.valor +
					" | " +
					animal.dias_gestacao.valor;
				return text;
			}
		},
		resetDieta() {
			this.$store.commit("getDefaultAnimalExigencias");
			this.$store.commit("getDefaultExigencias");
			this.alerta = null;
			this.step = 1;
			this.stepComplete = [false, false];
		},
		changeRadioAnimal(input, animal_) {
			const val = input.valor;
			const idInput = input.id;
			let animal = new Animal(this.$store.state, this.animal);
			animal.useFormat = false;
			var PLe = animal.producao_de_leite;
			var SL = animal.semana_lactacao;
			animal.useFormat = true;

			if (idInput === "estadoParides") {
				animal.useFormat = false;
				let result = 8.819 - 0.069 * SL - 8.819 * Math.exp(-3.211 * SL);
				switch (animal.estado_parides) {
					case PRIMIPARAS:
						result = 6.431 - 0.072 * SL - 6.431 * Math.exp(-2.188 * SL);
						break;
					case MULTIPARAS:
						result = 7.996 - 0.101 * SL - 7.996 * Math.exp(-1.447 * SL);
				}
				PLe = result;
				if (PLe > 0 && SL <= 40) {
					animal.producao_de_leite = PLe;
				}
				animal.useFormat = true;
				this.$store.commit("setTipoAnimal", animal.getData());
			}
			if (val === CRESCIMENTO_TERMINACAO || val === VACA || val === BEZERRO) {
				this.$store.commit("getDefaultAnimal");
				this.$nextTick(() => {
					this.resetDieta();
					this.animal.tipo.valor = val;
					this.$store.commit("setTipoAnimal", this.animal);
					this.$store.commit("setAlimentosSelecionados", []);
					this.$refs.formAnimal.validate();
				});
			}
		},
		rulesAnimal(input, animal, idioma) {
			var rule = [];
			if (input.focus !== undefined && input.focus === true) return [];
			if (idioma === undefined) idioma = this.idioma;

			if (input.maxBezerro && animal.tipo.valor === BEZERRO) {
				if (input.maxBezerro < this.parseString(input.valor, idioma)) {
					input.valor = input.maxBezerro.toFixed(0);
				}
				if (input.maxBezerro < this.parseString(input.valor, idioma)) {
					rule.push(
						(idioma === 0 || idioma === 2
							? "Valor deve ser manor ou igual que "
							: "Value must be less or equal than ") +
							String(input.maxBezerro).replace(/[.]/g, ",")
					);
				}
			}

			if (!input.required) {
				if (idioma === 0 || idioma === 2) {
					if (input.minDepende !== undefined && input.valor) {
						input.minDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
											parseFloat(
												input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
											) ||
										"Valor deve ser maior que " +
											String(input.max).replace(/[.]/g, ",")
								);
							}
						});
					}
					if (input.maxDepende !== undefined && input.valor) {
						input.maxDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(
											input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
										) === 0 ||
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
											parseFloat(
												input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
											) ||
										"Valor deve ser menor que " + input2.title[idioma]
								);
							}
						});
					}
					if (input.max !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									input.max ||
								"Valor deve ser menor que " +
									String(input.max).replace(/[.]/g, ",")
						);
					}
					if (input.min !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
									input.min ||
								"Valor deve ser maior que " +
									String(input.min).replace(/[.]/g, ",")
						);
					}
				} else if (idioma === 1) {
					if (input.minDepende !== undefined && input.valor) {
						input.minDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
											parseFloat(
												input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
											) ||
										"Value must be higher than " +
											String(input.max).replace(/[.]/g, ",")
								);
							}
						});
					}
					if (input.maxDepende !== undefined && input.valor) {
						input.maxDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(
											input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
										) === 0 ||
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
											parseFloat(
												input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
											) ||
										"Value must be less than " + input2.title[idioma]
								);
							}
						});
					}
					if (input.max !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) <= input.max ||
								"Value must be less than " +
									String(input.max).replace(/[.]/g, ",")
						);
					}
					if (input.min !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= input.min ||
								"Value must be higher than " +
									String(input.min).replace(/[.]/g, ",")
						);
					}
				}
			} else {
				if (input.valor === 0 || this.parseString(input.valor, idioma) === 0) {
					rule.push(
						idioma === 0
							? "Valor Não Aceito!!!"
							: idioma === 1
							? "Not Accepted Value!!!"
							: "¡¡¡Valor No Aceptado!!!"
					);
				}
				if (idioma === 0 || idioma === 2) {
					if (input.minDepende !== undefined && input.valor) {
						input.minDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
											parseFloat(
												input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
											) || "Valor deve ser maior que " + input2.title[idioma]
								);
							}
						});
					}
					if (input.maxDepende !== undefined && input.valor) {
						input.maxDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(
											input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
										) === 0 ||
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
											parseFloat(
												input2.valor.replace(/[.]/g, "").replace(/[,]/g, ".")
											) ||
										"Valor deve ser menor que " + input2.title[idioma]
								);
							}
						});
					}
					if (input.max !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									input.max ||
								"Valor deve ser menor que " +
									String(input.max).replace(/[.]/g, ",")
						);
					}
					if (input.min !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
									input.min ||
								"Valor deve ser maior que " +
									String(input.min).replace(/[.]/g, ",")
						);
					}
				} else if (idioma === 1) {
					if (input.minDepende !== undefined && input.valor) {
						input.minDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, "")) >=
											parseFloat(input2.valor.replace(/[,]/g, "")) ||
										"Value must be higher than " + input2.title[idioma]
								);
							}
						});
					}
					if (input.maxDepende !== undefined && input.valor) {
						input.maxDepende.forEach((dependencia) => {
							if (animal[dependencia]) {
								let input2 = animal[dependencia];
								rule.push(
									(v) =>
										parseFloat(input2.valor.replace(/[,]/g, "")) === 0 ||
										parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
											parseFloat(input2.valor.replace(/[,]/g, "")) ||
										"Value must be less than " + input2.title[idioma]
								);
							}
						});
					}
					if (input.max !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) <= input.max ||
								"Value must be less than " +
									String(input.max).replace(/[.]/g, ",")
						);
					}
					if (input.min !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= input.min ||
								"Value must be higher than " +
									String(input.min).replace(/[.]/g, ",")
						);
					}
				}
				if ((idioma === 0 || idioma === 2) && input.precisao) {
					if (input.max && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									input.max ||
								"Valor deve ser menor que " +
									String(input.max).replace(/[.]/g, ",")
						);
					}
					if (input.min !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= input.min ||
								"Valor deve ser maior que " +
									String(input.min).replace(/[.]/g, ",")
						);
					}
					rule.push(
						(v) => v !== "0,0" || this.strings[this.idioma].obrigatorio
					);
					rule.push(
						(v) => v !== "0,00" || this.strings[this.idioma].obrigatorio
					);
				} else if (idioma === 1 && input.precisao) {
					if (input.max && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) <= input.max ||
								"Value must be less than " + String(input.max)
						);
					}
					if (input.min !== undefined && input.valor) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= input.min ||
								"Value must be higher than " +
									String(input.min).replace(/[.]/g, ",")
						);
					}
					rule.push(
						(v) => v !== "0.0" || this.strings[this.idioma].obrigatorio
					);
					rule.push(
						(v) => v !== "0.00" || this.strings[this.idioma].obrigatorio
					);
				} else if (!input.precisao) {
					rule.push((v) => v !== "0" || this.strings[this.idioma].obrigatorio);
				}
				if (input.maxPeso && input.valor && (idioma === 0 || idioma === 2)) {
					if (animal.tipo.valor === this.BEZERRO) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									this.MAX_PESO_BEZERRO ||
								"Valor deve ser menor que " +
									String(this.MAX_PESO_BEZERRO).replace(/[.]/g, ",")
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
									this.MIN_PESO_BEZERRO ||
								"Valor deve ser maior que " +
									String(this.MIN_PESO_BEZERRO).replace(/[.]/g, ",")
						);
					} else if (animal.tipo.valor === this.VACA) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									this.MAX_PESO_FEMEA ||
								"Valor deve ser menor que " +
									String(this.MAX_PESO_FEMEA).replace(/[.]/g, ",")
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
									this.MIN_PESO_FEMEA ||
								"Valor deve ser maior que " +
									String(this.MIN_PESO_FEMEA).replace(/[.]/g, ",")
						);
					} else if (
						animal.tipo.valor === this.CRESCIMENTO_TERMINACAO &&
						(animal.sexo.valor === this.MACHO ||
							animal.sexo.valor === this.MACHO_CASTRADO)
					) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									this.MAX_PESO_MACHO ||
								"Valor deve ser menor que " +
									String(this.MAX_PESO_MACHO).replace(/[.]/g, ",")
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
									this.MIN_PESO_MACHO ||
								"Valor deve ser maior que " +
									String(this.MIN_PESO_MACHO).replace(/[.]/g, ",")
						);
					} else if (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
									this.MAX_PESO_MACHO ||
								"Valor deve ser menor que " +
									String(this.MAX_PESO_MACHO).replace(/[.]/g, ",")
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) >=
									this.MIN_PESO_MACHO ||
								"Valor deve ser maior que " +
									String(this.MIN_PESO_MACHO).replace(/[.]/g, ",")
						);
					}
				} else if (input.maxPeso && input.valor && idioma === 1) {
					if (animal.tipo.valor === this.BEZERRO) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) <= this.MAX_PESO_BEZERRO ||
								"Value must be less than " + String(this.MAX_PESO_BEZERRO)
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= this.MIN_PESO_BEZERRO ||
								"Value must be high than " + String(this.MIN_PESO_BEZERRO)
						);
					} else if (animal.tipo.valor === this.VACA) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) <= this.MAX_PESO_FEMEA ||
								"Value must be less than " + String(this.MAX_PESO_FEMEA)
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= this.MIN_PESO_FEMEA ||
								"Value must be high than " + String(this.MIN_PESO_FEMEA)
						);
					} else if (
						animal.tipo.valor === this.CRESCIMENTO_TERMINACAO &&
						(animal.sexo.valor === this.MACHO ||
							animal.sexo.valor === this.MACHO_CASTRADO)
					) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) <= this.MAX_PESO_MACHO ||
								"Value must be less than " + String(this.MAX_PESO_MACHO)
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= this.MIN_PESO_MACHO ||
								"Value must be high than " + String(this.MIN_PESO_MACHO)
						);
					} else if (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO) {
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, ".")) <= this.MAX_PESO_MACHO ||
								"Value must be less than " +
									String(this.MAX_PESO_MACHO).replace(/[.]/g, ",")
						);
						rule.push(
							(v) =>
								parseFloat(v.replace(/[,]/g, "")) >= this.MIN_PESO_BEZERRO ||
								"Value must be high than " + String(this.MIN_PESO_MACHO)
						);
					}
				}
			}
			if (!this.proximoAnimalClick) rule = [];
			return rule;
		},
		textAlignHeader(header, headers) {
			if (this.$vuetify.breakpoint.width >= 991) {
				if (
					header.text !== headers[0][3].text &&
					header.text !== headers[0][4].text &&
					header.text !== headers[0][5].text
				)
					return "text-align: left; font-size: 16px";
				else return "text-align: center; font-size: 16px";
			} else {
				if (
					header.text !== headers[1][1].text &&
					header.text !== headers[1][2].text &&
					header.text !== headers[1][3].text
				)
					return "text-align: left; font-size: 16px";
				else return "text-align: center; font-size: 16px";
			}
		},
	},
};
</script>
